<script setup lang="ts">
import { computed } from 'vue';

import type { ComboboxProps, ComboboxTypes } from './types';

import { comboboxDefaults } from './types';

interface Props extends ComboboxProps {
  as?: ComboboxTypes;
}

const props = withDefaults(defineProps<Props>(), {
  ...comboboxDefaults,
  as: 'search',
});

const emit = defineEmits<{
  blur: [];
}>();
const singleModel = defineModel<string | number | null>();
const multipleModel = defineModel<(string | number)[]>('values');

const sharedProps = computed(() => ({
  options: props.options,
  errorMessages: props.errorMessages,
  label: props.label,
  hideLabel: props.hideLabel,
  clearable: props.clearable,
  nullable: props.nullable,
  placeholder: props.placeholder,
  disabled: props.disabled,
  required: props.required,
  dataTestId: props.dataTestId ?? 'combobox',
  inputTypeState: props.inputTypeState,
  version: props.version,
  labelClass: props.labelClass,
}));
</script>

<template>
  <ClientOnly>
    <KUICoreInputComboboxSearch
      v-if="as === 'search'"
      v-bind="sharedProps"
      :model-value="singleModel ?? null"
      @update:model-value="singleModel = $event"
      @blur="emit('blur')"
    />
    <KUICoreInputComboboxMultiple
      v-else-if="as === 'multiple'"
      v-bind="sharedProps"
      :model-value="multipleModel ?? []"
      @update:model-value="multipleModel = $event"
      @blur="emit('blur')"
    />
    <KUICoreInputComboboxSelect
      v-else
      v-bind="sharedProps"
      :model-value="singleModel ?? null"
      @update:model-value="singleModel = $event"
      @blur="emit('blur')"
    />
    <template #fallback>
      <div class="flex w-fit flex-col items-start gap-2">
        <div class="h-1.5 w-24 animate-pulse bg-border" />
        <div class="border-border h-12.5 w-28 animate-pulse rounded-2xl border bg-muted" />
      </div>
    </template>
  </ClientOnly>
</template>
